import React, { useState } from 'react';
import AgentHeader from '../header/AgentHeader';
import styles from './APILogs.module.scss';
import TableComponent from 'component/molecules/Table/TableComponent';
import * as tableHeader from './factory/headerData';
import Button from 'component/atom/forms/button/Button';
import ViewDetailsModal from './view-details/ViewDetailsModal';
import { Agent } from 'hooks/endpoints';
import { useParams } from 'react-router-dom';

const APILogs = () => {
  const { id } = useParams();
  const [isView, setIsView] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const handleClose = () => {
    setIsView(false);
    setSelectedItem(null);
  };
  const renderComponent = (
    <Button
      label='Refresh Logs'
      opicBackground
      onClick={() => setRefetch((prev) => !prev)}
    />
  );

  const rightRowButton = ({ head, item }) => {
    return (
      <Button
        label='View'
        onClick={(e) => (
          e.stopPropagation(), setIsView(true), setSelectedItem(item)
        )}
        transparent={true}
      />
    );
  };
  return (
    <div className={styles.cont}>
      <AgentHeader
        // title="API Activity Logs"
        renderComponent={renderComponent}
        titleStyle={styles['title']}
      />

      <TableComponent
        rowKey='id'
        headerData={tableHeader.headerData}
        noPadding
        renderAdditionalComponent={rightRowButton}
        api={{
          get: {
            url: Agent.getApiLogs(id),
            queryKey: ['apiLogs', id],
          },
        }}
        isRefetch={refetch}
      />

      <ViewDetailsModal
        isOpen={isView}
        onClose={handleClose}
        selectedItem={selectedItem}
      />
    </div>
  );
};

export default APILogs;
